import {
  MDBAlert,
  MDBBtn,
  MDBCol,
  MDBInput,
  MDBScrollspy,
  MDBScrollspyLink,
  MDBSpinner,
  MDBTabs,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { downloadContacts, editUserStreamsSettings, getGoogleContactsRedirectHtml, getMisc, getSpecificUserStreams, getUserGlobalNotifications, getWSContactsRedirectHtml } from "../../../apiclients/streamsapi_bridge";
import SaveChanges from "../../topviews/saveCancel";
import UserStreamGeneral from "./UserStreamGeneral";
import UserStreamsNotification from "./UserStreamsNotification";
import UserStreamsSpeedDial from "./UserStreamsSpeedDial";
import { CSV, Google, Outlook } from "../../images";
import { show_links_tab } from "../../../apiclients/apiurls";
import { getStreamsProductName } from "../../../apiclients/CommonUtils";

export default function StreamsSettings({ useragent, setEdited, isActive, isstreamsReq }) {
  const [isloading, setIsloading] = useState(false);
  const containerRef = useRef(null);
  const general = useRef(null);
  const notifications = useRef(null);
  const speeddials = useRef(null);
  const ImportContacts = useRef(null);
  const msteams = useRef(null);
  const ReplicationService = useRef(null);
  const [resetDefault, setResetDefault] = useState({});
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [rerender, setRerender] = useState(false);
  const [activeTab, setaActiveTab] = useState("tab1");
  const [visibilityList, setVisibilityList] = useState({});
  const [contactOrderList, setContactOrderList] = useState({});
  const [soundList, setSoundList] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [speedDialList, setSpeedDialList] = useState([]);
  const [globalNotificationData, setGlobalNotificationData] = useState({});
  const [connectMeetingVisible, setConnectMeetingVisible] = useState(false);
  const [meetingroomenabled, setmeetingroomenabled] = useState(false);
  const isStreamsSettingReq = JSON.parse(sessionStorage.getItem("admin_session"))?.isStreamsSettingReq ?? 0;
  const [msTeamsVisible, setMSTeamsVisible] = useState(false);
  const [hideGlobalNotifications, setHideGlobalNotifications] = useState(false);
  const isWholesaleAcc = JSON.parse(sessionStorage.getItem("admin_session"))?.isWholesaleAcc ?? false;
  const [googleAuthLoading, setGoogleAuthLoading] = useState(false);
   const streamsProductName = getStreamsProductName(); 


  const { register, setValue, getValues, watch, setError, formState: { isDirty, dirtyFields, errors }, handleSubmit, reset, clearErrors } = useForm({
    defaultValues: {
      streams_general: {
        delete_msg: false,
        contact_name_order: 0,
        contact_visibility: 0,
        display_contact_ext: false,
        show_desktop_answer_pop_up: false,
        meeting_room_enabled: false,
      },
      streams_notifications: {
        mobile_notifications: false,
        desktop_notifications: false,
        mute_all_notifications: false,
        connect_IM_invite_sound: 0,
        new_msg_sound: 0,
        disable_notifications_likes: false,
        disable_notifications_daily_period: false,
        from_time: "",
        to_time: "",
        inc_unread_alert_muteall: false,
        inc_unread_alert_daily: false
      },
      global_notifications: {
        adds_content_owned: false,
        adds_content_shared: false,
        deletes_content_owned: false,
        deletes_content_shared: false,
        modifies_content_owned: false,
        modifies_content_shared: false,
        downloads_content_owned: false,
        downloads_content_shared: false,
      },
      multilogininfo: {
        loginflag: false,
        editflag: false
      },
      ms_teams_id: ""
      // streams_speed_dials: {
      //   add_speed_dial: {
      //     name: "",
      //     ph_num: "",
      //     speed_dial_number: 0
      //   },
      //   update_speed_dial: {
      //     name: bbb,
      //     ph_num: 92323289324,
      //     speed_dial_number: 1,
      //     speed_dial_id: 234
      //   },
      //   remove_speed_dials: [
      //     0,
      //     2,
      //     3
      //   ]
      // }

    }
  })

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  const setTabView = (value) => {
    if (value === activeTab) {
      return;
    }

    setaActiveTab(value);
  };

  async function getUserStreamsDetails() {
    try {
      setIsloading(true);
      const response = await getSpecificUserStreams(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        useragent
      );
      setTimeout(() => {
        setIsloading(false);
      }, 1000);
      const streamsdetails = await response.json();
      console.log("getSpecific User Streams settings ::: " + JSON.stringify(streamsdetails));
      const responseGlob = await getUserGlobalNotifications(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        useragent
      )
      const responseData = await responseGlob.json();
      console.log("Global Notification Response", responseData);
      setSpeedDialList(streamsdetails?.streams_settings?.streams_speed_dials ?? []);
      setConnectMeetingVisible(streamsdetails?.streams_settings?.streams_general?.connect_meeting_visible ?? false)
     setmeetingroomenabled(streamsdetails?.streams_settings?.streams_general?.meeting_room_enabled ?? false)
      setResetDefault(
        {
          streams_general: {
            delete_msg: streamsdetails?.streams_settings?.streams_general?.delete_msg ?? true,
            contact_name_order: streamsdetails?.streams_settings?.streams_general?.contact_name_order ?? 0,
            contact_visibility: streamsdetails?.streams_settings?.streams_general?.contact_visibility ?? 1,
            display_contact_ext: streamsdetails?.streams_settings?.streams_general?.display_contact_ext ?? true,
            show_desktop_answer_pop_up: streamsdetails?.streams_settings?.streams_general?.show_desktop_answer_pop_up ?? true,
            meeting_room_enabled: streamsdetails?.streams_settings?.streams_general?.meeting_room_enabled ?? false
          },
          streams_notifications: {
            mobile_notifications: streamsdetails?.streams_settings?.streams_notifications?.mobile_notifications ?? true,
            desktop_notifications: streamsdetails?.streams_settings?.streams_notifications?.desktop_notifications ?? true,
            mute_all_notifications: streamsdetails?.streams_settings?.streams_notifications?.muteAllNotifications ?? false,
            connect_IM_invite_sound: streamsdetails?.streams_settings?.streams_notifications?.connect_IM_invite_sound ?? 4,
            new_msg_sound: streamsdetails?.streams_settings?.streams_notifications?.new_msg_sound ?? 4,
            disable_notifications_likes: streamsdetails?.streams_settings?.streams_notifications?.disable_notifications_likes ?? false,
            disable_notifications_daily_period: streamsdetails?.streams_settings?.streams_notifications?.disable_notifications_daily_period ?? false,
            from_time: streamsdetails?.streams_settings?.streams_notifications?.from_time ?? "12:00 AM",
            to_time: streamsdetails?.streams_settings?.streams_notifications?.to_time ?? "11:59 PM",
            inc_unread_alert_muteall: streamsdetails?.streams_settings?.streams_notifications?.inc_unread_alert ?? false,
            inc_unread_alert_daily: streamsdetails?.streams_settings?.streams_notifications?.inc_unread_alert ?? false
          },
          global_notifications: {
            adds_content_owned: responseData?.user?.cb_content_added?.contentownvalue === "100" ? true : false,
            adds_content_shared: responseData?.user?.cb_content_added?.contentsharevalue === "100" ? true : false,
            deletes_content_owned: responseData?.user?.cb_content_deleted?.contentownvalue === "100" ? true : false,
            deletes_content_shared: responseData?.user?.cb_content_deleted?.contentsharevalue === "100" ? true : false,
            modifies_content_owned: responseData?.user?.cb_content_modified?.contentownvalue === "100" ? true : false,
            modifies_content_shared: responseData?.user?.cb_content_modified?.contentsharevalue === "100" ? true : false,
            downloads_content_owned: responseData?.user?.cb_content_downloaded_viewed?.contentownvalue === "100" ? true : false,
            downloads_content_shared: responseData?.user?.cb_content_downloaded_viewed?.contentsharevalue === "100" ? true : false
          },
          multilogininfo: {
            loginflag: streamsdetails?.multilogininfo?.loginflag !== undefined ? streamsdetails?.multilogininfo?.loginflag : false,
            editflag: streamsdetails?.multilogininfo?.editflag != undefined ? streamsdetails?.multilogininfo?.editflag : false
          },
          ms_teams_id: streamsdetails?.ms_team_info?.ms_teams_id ?? ""

        }
      );
      setMSTeamsVisible(streamsdetails?.ms_team_info?.ms_teams_visible ?? false);
      setHideGlobalNotifications(streamsdetails?.hide_global_notifications ?? false);
    } catch (error) {
      console.log(`Error in getUserStreamsDetails :::: ${error}`);
    }
  };
  useEffect(() => {
    if ((useragent !== "" || rerender) && isActive) {
      getUserStreamsDetails();
      setRerender(false);
    }
  }, [useragent, isActive, rerender]);


  useEffect(() => {
    if (Object.keys(resetDefault).length !== 0) reset(resetDefault);
  }, [resetDefault]);

  function closeSave(e) {
    reset();
    // setRerender(!rerender);
  }

  const isSave = Object.keys(dirtyFields).length === 0 ? false : true;

  useEffect(() => {
    setEdited(isSave);
  }, [isSave])

  const onSubmit = async (data) => {
    const modifiedData = {};
    for (const field of Object.keys(dirtyFields)) {
      // Check if the field is dirty and exists in the data object
      if (dirtyFields[field] && data.hasOwnProperty(field)) {
        // If the field is an object, extract modified subfields
        if (typeof data[field] === "object" && !Array.isArray(data[field])) {
          modifiedData[field] = {};

          for (const subfield of Object.keys(dirtyFields[field])) {
            if (data[field].hasOwnProperty(subfield)) {
              modifiedData[field][subfield] = data[field][subfield];
            }
          }
        } else {
          modifiedData[field] = data[field];
        }
      }
    }
    if (modifiedData) {
      modifiedData.reqid = 51;
      modifiedData.siteid = JSON.parse(
        sessionStorage.getItem("admin_session")
      ).siteid;
      modifiedData.agentid = useragent;
      // modifiedData.logined_user = JSON.parse(
      //   sessionStorage.getItem("admin_session")
      // ).logined_user;
      if (modifiedData?.streams_notifications?.disable_notifications_daily_period || modifiedData?.streams_notifications?.from_time || modifiedData?.streams_notifications?.to_time) {
        modifiedData.streams_notifications.from_time = data.streams_notifications.from_time;
        modifiedData.streams_notifications.to_time = data.streams_notifications.to_time;
      }      
      let streamsNotifFields = modifiedData?.streams_notifications;
      if(streamsNotifFields){
        if("inc_unread_alert_daily" in streamsNotifFields && watch("streams_notifications.disable_notifications_daily_period") !== false){
          modifiedData.streams_notifications.inc_unread_alert = streamsNotifFields.inc_unread_alert_daily;
        } else if("inc_unread_alert_muteall" in streamsNotifFields && watch("streams_notifications.mute_all_notifications") !== false){
          modifiedData.streams_notifications.inc_unread_alert = streamsNotifFields.inc_unread_alert_muteall;
        }
        delete modifiedData.streams_notifications.inc_unread_alert_daily;
        delete modifiedData.streams_notifications.inc_unread_alert_muteall;
      }
      modifiedData.global_notifications = getValues(`global_notifications`)
      console.log("modified data for user :::" + JSON.stringify(modifiedData));
      console.log(JSON.stringify(modifiedData));
      setIsloading(true);
      let saverep = await editUserStreamsSettings(modifiedData);
      console.log(`reponse of Edit user streams :::: ${JSON.stringify(saverep)}`);
      let saverepeMsg = await saverep.json();
      console.log(
        "response of modified data :::" + JSON.stringify(saverepeMsg)
      );
      setTimeout(() => {
        setIsloading(false);
      }, 1000);
      if (saverepeMsg.status && saverepeMsg.status == "success") {
        setRerender(true);
        setSuccessMessage(saverepeMsg.message);
      } else {
        // if (saverepeMsg.message?.errors) {
        //   saverepeMsg.message.errors.forEach((err) => {

        //     setError(err.param_name, {
        //       type: "server",
        //       message: err.message,
        //     });
        //     const fieldElement = document.querySelector(
        //       `input[name="${err.param_name}"]`
        //     );
        //     if (fieldElement) {
        //       fieldElement.focus();
        //       fieldElement.scrollIntoView({ behavior: "smooth" });
        //     }
        //   });
        // }
        if (saverepeMsg.message?.errors) {
          saverepeMsg.message.errors.forEach((errGroup) => {
            if (errGroup.param_name && errGroup.message) {
              setError(errGroup.param_name, {
                type: "server",
                message: errGroup.message,
              });
              const fieldElement = document.querySelector(
                `input[name="${errGroup.param_name}"]`
              );
              if (fieldElement) {
                fieldElement.focus();
                fieldElement.scrollIntoView({ behavior: "smooth" });
              }
            } else if (errGroup.errors) {
              errGroup.errors.forEach((err) => {
                setError(err.param_name, {
                  type: "server",
                  message: err.message,
                });
                const fieldElement = document.querySelector(
                  `input[name="${err.param_name}"]`
                );
                if (fieldElement) {
                  fieldElement.focus();
                  fieldElement.scrollIntoView({ behavior: "smooth" });
                }
              });
            }
          });
        }
      }
    }

  }

  useEffect(() => {
    getUserStreamsMisc();

  }, []);

  async function getUserStreamsMisc() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));
    updates = {
      misc: ["user_streams"],
    };

    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      updates
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const basicInfo = await response.json();
    if (!basicInfo) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("response data is :::::::::: " + basicInfo);
    setVisibilityList(basicInfo?.misc?.user_streams?.contact_display ?? {});
    setContactOrderList(basicInfo?.misc?.user_streams?.contact_order ?? {});
    setSoundList(basicInfo?.misc?.user_streams?.soundslist ?? {});
  }

  async function handleDownload() {
    try {
        let apiResponse = await downloadContacts(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        let filename = "Import Contacts.csv";
        if (apiResponse.status == 200) {
            const fileUrl = URL.createObjectURL(await apiResponse.blob());
            const a = document.createElement("a");
            a.href = fileUrl;
            a.download = filename;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } else {
            // setInternalError(true);
        }
    } catch (error) {
        console.log("Error ::::::::: " + error);
    }
  }

  async function redirectToWSContactAPI(e){
    try {
        e.preventDefault();
        let apiResponse = await getWSContactsRedirectHtml();
        if(apiResponse.status == 200){
            const html = await apiResponse.text();
            // Open blank popup and inject HTML
            const popup = window.open("", "_blank", "toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600");
            popup.document.open();
            popup.document.write(html);
            popup.document.close();
        }
    } catch (error) {
        
    }
  }

  async function redirectToGoogleContactsAPI(e) {
    try {
      e.preventDefault();
      setGoogleAuthLoading(true);

      const apiResponse = await getGoogleContactsRedirectHtml();
      if (apiResponse.status == 200) {
        const html = await apiResponse.text();
        // Open blank popup and inject HTML
        const popup = window.open("", "_blank", "toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600");
        popup.document.open();
        popup.document.write(html);
        popup.document.close();
      }
    } catch (error) {
      console.error('Failed to redirect to Google contacts API:', error);
    } finally {
      setGoogleAuthLoading(false);
    }
  }

  return (
    <>
      <div className="row">
        <MDBCol
          size="2"
          md="2"
          lg="2"
          sm="12"
          className="col-sm-100 pr-0  leftTabs"
        >
          <MDBTabs className="flex-column text-center">
            <MDBScrollspy
              container={containerRef}
              defaultActive="general"
            >
              <MDBScrollspyLink targetRef={general}>
                {t("general")}
              </MDBScrollspyLink>
              <MDBScrollspyLink targetRef={notifications}>
                {t("Notifications")}
              </MDBScrollspyLink>
              <MDBScrollspyLink targetRef={speeddials}>
                {t("SpeedDials")}
              </MDBScrollspyLink>
              {isStreamsSettingReq === 1 && (<>
                <MDBScrollspyLink targetRef={ImportContacts}>
                  Import Contacts
                </MDBScrollspyLink>
                {/* <MDBScrollspyLink targetRef={ReplicationService}>
                  Replication Service
                </MDBScrollspyLink> */}
              </>)}
               { msTeamsVisible && !isWholesaleAcc &&
                <MDBScrollspyLink targetRef={msteams}>
                  {t("msteams")}
                </MDBScrollspyLink>
              }
            </MDBScrollspy>
          </MDBTabs>
        </MDBCol>
        <MDBCol
          size="12"
          md="10"
          sm="12"
          pr-0
          className="col-sm-100 pr-0 leftTabContent"
        >
          <div className="vtabHeight ps-2 pr-5">
            <div className="w-95">
              <div
                id="element"
                ref={containerRef}
                className="scrollspy-example"
              >
                <form>
                  <section ref={general} id="section-1">
                    <UserStreamGeneral
                      register={register}
                      errors={errors}
                      visibilityList={visibilityList}
                      contactOrderList={contactOrderList}
                      isstreamsReq={isstreamsReq}
                      watch={watch}
                      useragent={useragent}
                      setIsloading = {setIsloading}
                      setValue={setValue}
                      connectMeetingVisible = {connectMeetingVisible}
                      meetingroomenabled = {meetingroomenabled}
                    />
                  </section>
                  <section ref={notifications} id="section-2">
                    <UserStreamsNotification
                      register={register}
                      errors={errors}
                      soundList={soundList}
                      watch={watch}
                      clearErrors={clearErrors}
                      setValue={setValue}
                      hideGlobalNotifications={hideGlobalNotifications}
                    />
                  </section>
                  <section ref={speeddials} id="section-3">
                    <UserStreamsSpeedDial
                      speedDialList={speedDialList}
                      setSuccessMessage={setSuccessMessage}
                      useragent={useragent}
                      isstreamsReq={isstreamsReq}
                    />
                  </section>
                  {isStreamsSettingReq === 1 && (<>
                    <div className="routing-border mt-2"></div>

                  <section ref={ImportContacts} id="section-4">
                    <div className="general-settings" id="Notifications">
                      Import Contacts
                    </div>

                    {/* Google Contacts Section - Simplified to match CSV pattern */}
                    <div className="border rounded-4 shadow-4 p-4">
                      <div className="d-flex align-items-center justify-content-between w-100 mb-3">
                        <button
                          className="google-signin-btn d-flex align-items-center"
                          onClick={redirectToGoogleContactsAPI}
                        >
                          <img src={Google} alt="Google logo" className="google-logo me-2" />
                        
                        </button>
                      </div>

                      <p className="mt-2 mb-0">
                        You will always have full control over the contacts imported to {streamsProductName}.When you import your Google contacts, we'll upload detailed information about your contacts to {streamsProductName}. When you are prompted to enter your Google password, we will ensure that it is only to authenticate your account.Once your Google contacts are imported,you can collaborate with them using the features in {streamsProductName}
                      </p>
                    </div>



                      <div className="border rounded-4 shadow-4 p-4 mt-4">
                        <div className="d-flex align-items-center justify-content-between w-100 mb-3">
                          <div className="d-flex align-items-center ">
                            <img src={CSV} alt="" className="impotedContactIcon" />
                            <p className="fw-bold fs-5">
                              Desktop *.CSV File Contacts
                            </p>
                          </div>
                          <MDBBtn onClick = { redirectToWSContactAPI }>Import</MDBBtn>
                        </div>


                        <p className="mt-2">
                          Click <a className="text-primary" onClick = { handleDownload }>here</a> to download the import contacts template.
                        </p>
                        <p>
                          <a className="text-primary pe-2" onClick = { redirectToWSContactAPI }>
                            Import
                          </a>
                          generic desktop *.CSV file contacts into Streams. Imported contacts will be displayed under Personal and Global Contacts section in {streamsProductName} and will replace the existing contacts.
                        </p>
                      </div>

                      {/* <div className="border rounded-4 shadow-4 p-4 mt-4">
                        <div className="d-flex align-items-center justify-content-between w-100 mb-3">
                          <div className="d-flex align-items-center ">

                            <img src={Outlook} alt="" className="impotedContactIcon" />
                            <p className="fw-bold fs-5">
                              Outlook Contacts (plugin to Outlook)
                            </p>
                          </div>
                          <MDBBtn>Download</MDBBtn>
                        </div>



                        <p className="my-2">
                          Download and install this plug-in to provide the following Outlook features:
                        </p>


                        <ul>
                          <li>
                            Outlook contact import feature provides the ability to import Outlook contacts into Streams from within Outlook.
                          </li>
                          <li>
                            Outlook Click to Call feature allows you to "click to call" a contact from within Outlook using the Streams built-in communications feature.
                          </li>
                          <li>
                            Streams file attachment feature in Outlook allows you to send file attachments via Streams automatically within Outlook.
                          </li>
                        </ul>


                      </div> */}


                    </section>
                    {/* <div className="routing-border mt-2"></div>
                    <section ref={ReplicationService} id="section-5">

                      <div className="general-settings" id="Notifications">
                        Replication Service
                      </div>

                      <div className="d-flex align-items-center justify-content-between fw-bold ps-3">
                        SmartBox Replication Service:
                        <MDBBtn className="ms-3">
                          Go
                        </MDBBtn>
                      </div>
                    </section> */}
                  </>)}
                  { msTeamsVisible && !isWholesaleAcc && <>
                    <div className="routing-border p-0"></div>
                    <section ref={msteams} id="section-5">
                      <div className="general-settings">
                      {t("msteams")}
                      <div className="add-numbermain">
                        <div className="tel-numbers">{t("msteamsid")}</div>
                        <div className="w-30">
                        <MDBInput type="text" className="w-100" {...register("ms_teams_id")}
                          onChange={(e) => {
                            setValue(`ms_teams_id`, e.target.value, { shouldDirty: true });
                            clearErrors("ms_teams_id");
                          }}
                          />
                          {errors?.ms_teams_id && (
                              <p className="text-danger">{errors?.ms_teams_id.message}</p>
                          )}
                        </div>
                      </div>
                      </div>
                    </section>  
                  </>
                  }

                </form>
              </div>
            </div>
          </div>
        </MDBCol>
      </div>
      {isSave && (
        <SaveChanges
          onClose={closeSave}
          isdirtyFields={isSave}
          onSave={(e) => {
            e.preventDefault();
            handleSubmit(onSubmit)();
          }}
        />
      )}
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
      {successMessage && (
        <MDBAlert
          open
          className="alert-center"
          color="success"
          autohide
          position="bottom-right"
          delay={10000}
        >
          <i className="fas fa-check-circle me-3"></i>
          <span className="alert-msg">{successMessage}</span>
        </MDBAlert>
      )}

    </>
  );
}